/**
 * Recurring lesson booking.
 *
 * Shown in the Book a Lesson modal right after a student picks a slot and
 * presses Book. When the tutor also has the same slot free in the following
 * weeks, the student can book those in one go. Kept behind this flag so it
 * can be rolled out gradually.
 */

/** PostHog multivariate flag. */
export const RECURRING_BOOKING_FEATURE_FLAG = 'recurring-booking-new';

export const RECURRING_BOOKING_VARIANTS = {
  CONTROL: 'control',
  TEST: 'test',
} as const;

/**
 * Cap on lessons booked in one go, counting the picked slot. The backend
 * enforces the same limit (COURSE_LESSON_MAX_BOOKINGS_PER_REQUEST).
 */
export const MAX_LESSONS_PER_BOOKING = 4;
